import OpenAI from "openai";

export const openaiAPI = new OpenAI({
  apiKey: process.env.REACT_APP_OPEN_AI,
  dangerouslyAllowBrowser: true,
});

export const defaultMessageList = [
  "How am I doing financially?",
  "How should I improve my finances?",
  "Any opportunities for me today?",
  "Learn about Stocks",
  "Learn about Crypto",
  "Financial Wellness",
  "Goals",
  "Portfolio Overview",
  "Portfolio Value over time",
  "Portfolio Current Position",
  "Portfolio Asset Allocation by Asset Class",
  "Portflio Target Allocation",
  "Asset Details",
  "Liability Details",
  "How do I meet my Goals",
  "Opportunities that fit my portfolio",
  "Trending Opportunities",
  "Undervalued stocks",
  "Market News",
  "Market Report",
  "Economy Report",
  "Personal Finance Report",
  "Portfolio Report",
  "Crypto News",
  "Stock News",
  "Forex News",
  "General News",
  "Financial Projections",
  "Asset Projections",
  "Goal Projections",
  "Liability Projections",
  "Cashflow Projection",
  "Income Projection",
];

export const assistants = {
  Facilitator: "asst_NrPXIaeh3hvkFUxRH7qDwVPQ",
  FinancialPlanning: "asst_Kz7EFnoubtii1BneOAcP1Wxp",
  PortfolioManager: "asst_qzgbS56YOiIkDboNYECHrb0u",
  OpportunityFinder: "asst_VbQE5KkazFzWCKpnr4LqwLBO",
  TickerAnalyst: "asst_QxNGYOCNjN96wMZn3qeA8zU0",
  EconomyAnalyst: "asst_OeN9QDXepZMqZeXfaNZucmLD",
  NewsAssistant: "asst_a2ij5cLsndx0pT3l1YOHDE0i",
  ReportBuilder: "asst_3Zw6GN1156CVmAOX4lgZsNAX",
  FinancialProductAnalyst: "asst_qpIrizTB07DGJGBWi4xoNXTt",
  GeneralAssistant: "asst_Xo1pbVZvf8P8iyqr6bXxqzkZ",
  AdvisorAssistant: "asst_TWtZnro8JhooiAl7jcqbOySS",
  NotifyAssistant: "asst_Nyy0pY807zzkqDl9JUjezfeh",
};

export const assistantDetails = [
  {
    assistant: "Supervisor",
    id: assistants.Facilitator,
    name: "Facilitator",
    image: "/path/to/supervisor-image.jpg",
  },
  {
    assistant: "FinancialPlanning",
    id: assistants.FinancialPlanning,
    name: "Financial Advisor",
    image: "/path/to/financial-planning-image.jpg",
  },
  {
    assistant: "PortfolioManager",
    id: assistants.PortfolioManager,
    name: "Portfolio Manager",
    image: "/path/to/portfolio-manager-image.jpg",
  },
  {
    assistant: "OpportunityFinder",
    id: assistants.OpportunityFinder,
    name: "Trend Spotter",
    image: "/path/to/opportunity-finder-image.jpg",
  },
  {
    assistant: "TickerAnalyst",
    id: assistants.TickerAnalyst,
    name: "Market Analyst",
    image: "/path/to/ticker-analyst-image.jpg",
  },
  {
    assistant: "EconomyAnalyst",
    id: assistants.EconomyAnalyst,
    name: "Economy Analyst",
    image: "/path/to/economy-analyst-image.jpg",
  },
  {
    assistant: "NewsAssistant",
    id: assistants.NewsAssistant,
    name: "News Specialist",
    image: "/path/to/market-news-image.jpg",
  },
  {
    assistant: "ReportBuilder",
    id: assistants.ReportBuilder,
    name: "Reporting Analyst",
    image: "/path/to/general-assistant-image.jpg",
  },
  {
    assistant: "FinancialProductAnalyst",
    id: assistants.FinancialProductAnalyst,
    name: "Financial Product Analyst",
    image: "/path/to/general-assistant-image.jpg",
  },
  {
    assistant: "GeneralAssistant",
    id: assistants.GeneralAssistant,
    name: "Geek",
    image: "/path/to/general-assistant-image.jpg",
  },
  {
    assistant: "AdvisorAssistant",
    id: assistants.AdvisorAssistant,
    name: "Advisor",
    image: "/path/to/general-assistant-image.jpg",
  },
  {
    assistant: "NotifyAssistant",
    id: assistants.NotifyAssistant,
    name: "Notify",
    image: "/path/to/general-assistant-image.jpg",
  },
];

export const initialStateAssistant = {
  assistantId: assistants.Facilitator,
  threadId: null,
  runId: null,
  chats: [],
  chatGptMessage: "",
  loading: false,
  loadingMessage: "",
  openai: openaiAPI,
  showContent: false,
  voiceRecording: false,
  chatStatus: "idle",
  userMode: "New",
  defaultQuestionList: [...defaultMessageList],
  chatHistory: [],
  questionHistory: [],
  componentProps: [],
  questionChat: [],
  chatWindow: true,
  exploreQuestions: false,
  exploreAssistants: false,
  assistantSelected: assistants.Facilitator,
  chatUserDemo: [{ financialView: "", demoProfile: "" }],
  topQuestions: undefined,
  aiSummaryStore: [],
};

export const messagePlaceholders = [
  "Ask Quinn anything finance...",
  "How am I doing financially?",
  "How should I improve my finances?",
  "Any opportunities for me today?",
  "Am I beating the market?",
  "How much am I burning monthly?",
  "Am I meeting my Goals?",
];
